export default "__VITE_ASSET__DtOsMXY8__"